module.exports = __webpack_public_path__ + "img/ic-cuenta publicagris.d02f0887.png";